var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.829102 31.4908H47.2567C47.7145 31.4908 48.0858 31.1196 48.0858 30.6617V0.815431C48.0858 0.357583 47.7145 -0.0136719 47.2567 -0.0136719H0.829102C0.371255 -0.013578 0 0.357583 0 0.815431V30.6617C0 31.1196 0.371255 31.4908 0.829102 31.4908Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0857 6.61926H0V24.8589H48.0857V6.61926Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3119 15.7386L21.0149 12.5753C21.0797 12.284 20.8579 12.0077 20.5595 12.0077H20.0643C19.7659 12.0077 19.5443 12.284 19.6089 12.5753L20.3119 15.7386Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1405 14.0801H19.4824V21.1267H21.1405V14.0801Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5556 13.2516H19.0684V14.0807H21.5556V13.2516Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5557 15.7385H17.4102V16.5676H21.5557V15.7385Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5556 19.055L19.0684 18.226V17.3969L21.5556 18.226V19.055Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87634 15.7386L8.57931 12.5753C8.64412 12.284 8.42238 12.0077 8.12391 12.0077H7.62878C7.3304 12.0077 7.10875 12.284 7.17337 12.5753L7.87634 15.7386Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7783 13.2512C10.3205 13.2512 9.94922 13.6225 9.94922 14.0803V19.4692C9.94922 20.4765 10.8893 22.371 14.0945 22.371C17.2998 22.371 18.2399 20.4766 18.2399 19.4692V14.0803C18.2399 13.6225 17.8686 13.2512 17.4108 13.2512H10.7783Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0945 17.3965H9.94922V14.0803C9.94922 13.6225 10.3205 13.2512 10.7783 13.2512H14.0945V17.3965Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0938 17.3964H18.2391V19.469C18.2391 20.6138 17.3112 21.5417 16.1664 21.5417C15.0217 21.5417 14.0938 20.6138 14.0938 19.469V17.3964V17.3964Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94922 17.3969H14.0945V19.4695C14.0945 20.6143 13.1666 21.5422 12.0219 21.5422C10.8771 21.5422 9.94922 20.6143 9.94922 19.4695V17.3969V17.3969Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 21.1183V17.3969H12.4355V21.5004C12.744 21.4378 13.0226 21.3013 13.2646 21.1183Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6064 21.5004V17.3969H10.7773V21.1183C11.0195 21.3013 11.2981 21.4378 11.6064 21.5004Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 15.7385H10.7773V16.5676H13.2646V15.7385Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2646 14.0801H10.7773V14.9092H13.2646V14.0801Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8495 14.5731H11.1914V16.075H12.8495V14.5731Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70499 14.0801H7.04688V21.1267H8.70499V14.0801Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12003 20.7131H6.63281V21.5422H9.12003V20.7131Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12003 13.2516H6.63281V14.0807H9.12003V13.2516Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53497 21.5416H6.21875V22.3707H9.53497V21.5416Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9696 20.7136H19.4824V21.5427H21.9696V20.7136Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9705 21.5416H18.6543V22.3707H21.9705V21.5416Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5818 12.4224H11.6074V13.2515H16.5818V12.4224Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5088 9.93542H13.6797V12.4226H14.5088V9.93542Z",
    fill: "#FFB441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.265 11.1788C12.5793 11.1788 12.0215 10.6209 12.0215 9.93521C12.0215 9.24943 12.5794 8.69165 13.265 8.69165C13.9508 8.69165 14.5086 9.24952 14.5086 9.93521C14.5087 10.6209 13.9508 11.1788 13.265 11.1788ZM13.265 9.52066C13.0364 9.52066 12.8505 9.70643 12.8505 9.93521C12.8505 10.1639 13.0363 10.3498 13.265 10.3498C13.4938 10.3498 13.6796 10.164 13.6796 9.93521C13.6796 9.70652 13.4938 9.52066 13.265 9.52066Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9232 11.1788C14.2375 11.1788 13.6797 10.6209 13.6797 9.93521C13.6797 9.24943 14.2376 8.69165 14.9232 8.69165C15.609 8.69165 16.1668 9.24952 16.1668 9.93521C16.1668 10.6209 15.6089 11.1788 14.9232 11.1788ZM14.9232 9.52066C14.6946 9.52066 14.5087 9.70643 14.5087 9.93521C14.5087 10.1639 14.6945 10.3498 14.9232 10.3498C15.1519 10.3498 15.3378 10.164 15.3378 9.93521C15.3377 9.70652 15.1519 9.52066 14.9232 9.52066Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5814 12.0077C15.8957 12.0077 15.3379 11.4499 15.3379 10.7642C15.3379 10.0784 15.8958 9.52063 16.5814 9.52063C17.2672 9.52063 17.825 10.0785 17.825 10.7642C17.825 11.4499 17.2671 12.0077 16.5814 12.0077ZM16.5814 10.3496C16.3528 10.3496 16.1669 10.5354 16.1669 10.7642C16.1669 10.9929 16.3527 11.1787 16.5814 11.1787C16.8101 11.1787 16.996 10.993 16.996 10.7642C16.996 10.5354 16.8101 10.3496 16.5814 10.3496Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6068 12.0077C10.9211 12.0077 10.3633 11.4499 10.3633 10.7642C10.3633 10.0784 10.9211 9.52063 11.6068 9.52063C12.2926 9.52063 12.8504 10.0785 12.8504 10.7642C12.8505 11.4499 12.2926 12.0077 11.6068 12.0077ZM11.6068 10.3496C11.3782 10.3496 11.1923 10.5354 11.1923 10.7642C11.1923 10.9929 11.3781 11.1787 11.6068 11.1787C11.8356 11.1787 12.0214 10.9929 12.0214 10.7641C12.0214 10.5354 11.8356 10.3496 11.6068 10.3496Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.582 19.0548V19.4694C16.582 19.698 16.3961 19.884 16.1675 19.884C15.9389 19.884 15.7529 19.698 15.7529 19.4694V19.0548H16.582ZM17.411 18.2258H14.9238V19.4694C14.9238 20.1552 15.4817 20.713 16.1674 20.713C16.8532 20.713 17.4109 20.1551 17.4109 19.4694V18.2258H17.411Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.167 16.5679C15.7091 16.5679 15.3379 16.1966 15.3379 15.7388V14.9097C15.3379 14.4518 15.7091 14.0806 16.167 14.0806C16.6248 14.0806 16.9961 14.4518 16.9961 14.9097V15.7388C16.9961 16.1966 16.6248 16.5679 16.167 16.5679Z",
    fill: "#FFA0D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0932 18.64C14.78 18.64 15.3367 18.0832 15.3367 17.3964C15.3367 16.7096 14.78 16.1528 14.0932 16.1528C13.4064 16.1528 12.8496 16.7096 12.8496 17.3964C12.8496 18.0832 13.4064 18.64 14.0932 18.64Z",
    fill: "#5064AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5088 8.27698H13.6797V10.7642H14.5088V8.27698Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6064 12.4223L10.7773 11.5932L11.263 11.1075C12.0137 10.3568 13.0319 9.93506 14.0937 9.93506C15.1554 9.93506 16.1735 10.3568 16.9243 11.1075L17.41 11.5932L16.5809 12.4223H11.6064Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0942 12.0077C14.3232 12.0077 14.5088 11.8221 14.5088 11.5931C14.5088 11.3642 14.3232 11.1786 14.0942 11.1786C13.8653 11.1786 13.6797 11.3642 13.6797 11.5931C13.6797 11.8221 13.8653 12.0077 14.0942 12.0077Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.436 12.0077C12.665 12.0077 12.8506 11.8221 12.8506 11.5931C12.8506 11.3642 12.665 11.1786 12.436 11.1786C12.2071 11.1786 12.0215 11.3642 12.0215 11.5931C12.0215 11.8221 12.2071 12.0077 12.436 12.0077Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7524 12.0077C15.9814 12.0077 16.167 11.8221 16.167 11.5931C16.167 11.3642 15.9814 11.1786 15.7524 11.1786C15.5235 11.1786 15.3379 11.3642 15.3379 11.5931C15.3379 11.8221 15.5235 12.0077 15.7524 12.0077Z",
    fill: "#FFD250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7783 15.7385H6.63281V16.5676H10.7783V15.7385Z",
    fill: "#C8414B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63281 19.0546L9.11993 18.2256V17.3965L6.63281 18.2256V19.0546Z",
    fill: "#C8414B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 31.4804,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/Spanish.271341fa6dccdf9048637de5abd2473d.svg";
export { ForwardRef as ReactComponent };